import { ProjectTCO } from '../models/tco-info';
import {BasicHistoryListModel} from '../models/basic-history-list.model';
import {ProjectModel} from '../models/project.model';
import {ProjectsListItemModel, ProjectsListItemPagingModel} from '../models/projects-list-item.model';
import {ProjectsApprovalListItemModel} from '../models/projects-approval-list-item.model';
import {QuotesModel} from '../models/quotes.model';
import {MyApprovalStatusEnum} from '../enums/my-approval-status.enum';
import { ProjectListOrderByModel } from '../models/project-list-order-by.model';
import {ProjectListItemFilterModel} from '../models/project-list-item-filter.model';
import {HttpServiceBase} from '../../../core/services/http-service-base';

export abstract class IProjectService extends HttpServiceBase {


    public abstract getProjects(): Promise<ProjectsListItemModel[]>;

    public abstract getProjectsPaging(size:number, page:number, orderByParams: ProjectListOrderByModel, filterParams: ProjectListItemFilterModel): Promise<ProjectsListItemPagingModel>;


    public abstract getProjectPriceApprovals(approvalStatus?: MyApprovalStatusEnum): Promise<ProjectsApprovalListItemModel[]>;

    public abstract getProject(projectId: number, lockProject?: boolean): Promise<ProjectModel>;

    public abstract removeProject(projectId: number): Promise<void>;

    public abstract copyProject(projectId: number): Promise<{ id: number }>;


    // // should be removed, has not sense for new spec
    // public abstract saveProject(project: ProjectModel): Promise<boolean>;

    public abstract createProject(project: ProjectModel): Promise<boolean>;

    public abstract updateProject(project: ProjectModel, generateQuotes?: boolean): Promise<QuotesModel>;

    public abstract getProjectBasicHistory(projectId: number): Promise<BasicHistoryListModel>;

    public abstract createProjectDraft(project: ProjectModel): Promise<void>;

    public abstract updateProjectDraft(project: ProjectModel): Promise<void>;

    public abstract updateProjectStatusDetail(projectId: number, statusDetail: string, comment?: string): Promise<void>;

    public abstract getQuotesForProject(projectId: number): Promise<QuotesModel>;

    public abstract unlockProjectById(projectId: number): Promise<void>;

    public abstract getProjectTCO(projectId: number): Promise<ProjectTCO>;

}
